module.exports = __webpack_public_path__ + "fonts/3c68c184076549978534ce7d7f5918b9.0e2724f1.ttf";